/* eslint-disable no-use-before-define */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

const filter = createFilterOptions();

export default function AutocompleteSelectWithEntry({dropdownList, value, label, className, disabled, onChange, width, onBlur}) {

  return (
    <Autocomplete
      value={value}
      disabled={disabled}
      className={className}
      onChange={(event, newValue) => {
          onChange(event);
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        // Suggest the creation of a new value
        if (params.inputValue !== '') {
          filtered.push(
            params.inputValue
          );
        }
        return filtered;
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      id="free-solo-with-text-demo"
      options={dropdownList}
      getOptionLabel={(option) => {
        // Regular option
        return option;
      }}
      renderOption={(option) => option}
      style={{ width: width }}
      freeSolo
      renderInput={(params) => (
        <TextField {...params} label={label} style={{width: '100%'}} onBlur={onBlur} variant="outlined" disabled={disabled} size='small'/>
      )}
    />
  );
}

